import * as React from "react";

import { BulkyActionPicker, IActionCommand } from "../../../../common/component/action/action-select/bulky-action-picker";

import { ManageParcelActionType } from "../../../constants/constants";
import { Parcel } from "../../../model/parcel";
import { observer } from "mobx-react";
import { t } from "i18next";
import { Permission } from "../../../../context/permission";
import { operationContext } from "../../../../context/operation-context";

interface IParcelManagementHeaderProps {
    actionsList: Array<IActionCommand<Parcel, ManageParcelActionType>>;
    reloadParcelsList: () => Promise<void>;
}

@observer
export class ParcelManagementHeader extends React.Component<IParcelManagementHeaderProps, {}> {

    public render() {
        return <div className="list-actions-container">
            <div className="list-actions">
                <BulkyActionPicker withScanMode={true}
                                   propertyKey={operationContext.operationCodeOrEmpty}
                                   scanFieldType="text"
                                   inputLabel=""
                                   contentPrefix="parcelManagement.action"
                                   actions={this.props.actionsList}
                                   permission={Permission.FrontWrite} />
            </div>
        </div>;
    }

    protected getSuccessMessage(manageParcelAction: ManageParcelActionType, nbProcessed: number) {
        if (nbProcessed === 0) {
            return t(`parcelManagement.action.${manageParcelAction}.noItems`);
        }
        const isMultiple = nbProcessed > 1;
        return t(`parcelManagement.action.${manageParcelAction}.success` + (isMultiple ? "s" : ""),
            { count: nbProcessed });
    }
}
